<template>
  <div>
    <v-row>
      <v-col cols="4">
        <site-group-filter store="audience" />
      </v-col>
      <v-col cols="8">
        <site-filter
          store="audience"
        />
      </v-col>
      <v-col cols="6">
        <date-filter store="audience" periodType="past-only" />
      </v-col>
      <v-col cols="4">
        <redac-filter store="audience" />
      </v-col>
      <v-col cols="2" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="disableSearch" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter";
import RedacFilter from "@/components/common/filters/RedacFilter";
import SiteFilter from "@/components/common/filters/SiteFilter";
import SiteGroupFilter from "@/components/common/filters/SiteGroupFilter";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
    RedacFilter,
    SiteFilter,
    SiteGroupFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();
    const { store } = useProxy();

    // =>  METHODS

    // =>  COMPUTED
    const sites = computed(
      () => store.getters["audience/getSites"]
    );
    const rangeDate = computed(() => store.getters["audience/getDates"]);
    const disableSearch = computed(
      () => sites.value.length === 0 || rangeDate.value.length !== 2 || isLoading.value
    );

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      disableSearch,
    };
  },
};
</script>

<style></style>
